import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { renderFormMixins } from '@/mixins/renderFormMixins'; //import { get_import_sn_did } from '@/api/product'

import config from '@/config/index';
import { get_import_sn_did } from "@/api/chuku";
export default {
  name: "addModalCode",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      downloadexampleurl: '',
      columns1: [{
        title: 'Did',
        key: 'did'
      }, {
        title: 'Sn',
        key: 'sn'
      }],
      data1: [],
      modal1: false,
      project_codeData: {},
      formModel: {
        filename: null,
        model_code: null,
        project_code: null
      },
      formRules: {
        filename: [{
          required: true,
          type: 'object',
          message: this._vm.$t('productModule.uploadcsv'),
          trigger: 'change'
        }],
        project_code: [{
          required: true,
          message: this._vm.$t('productModule.projectcodeholder'),
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {},
    project_codeData: {},
    model_code: {}
  },
  components: {},
  computed: {
    getRoot: function getRoot() {
      var root = '';

      if (process.env.NODE_ENV === 'development') {
        root = config.baseUrl.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.baseUrl.pro;
      } else {
        root = config.baseUrl.alp;
      }

      return root;
    }
  },
  methods: {
    on_changeData: function on_changeData(value, clicktype) {
      //  console.log("value",value)
      for (var i = 0; i < this.project_codeData.length; i++) {
        if (value == this.project_codeData[i].project_code) {
          this.formModel.model_code = this.project_codeData[i].model_code;
        }
      }

      console.log("formmodel", this.formModel);
    },
    handleUpload: function handleUpload(file) {
      var _this = this;

      if (file.name.indexOf('.csv') > -1) {
        this.$set(this.formModel, 'filename', file);
        var formData = new FormData();
        formData.append('filename', file);
        formData.append('model_code', this.formModel.model_code);
        get_import_sn_did(formData).then(function (res) {
          var msg = res.errorMsg;

          if (res.result === 0) {
            console.log(111);

            _this.$set(_this, 'data1', res.body);

            _this.$Message.success({
              content: res.errorMsg,
              duration: 10,
              closable: true
            });
          } else {
            _this.$Message.error(msg);
          }
        });
      } else {
        this.$Message.error(this._vm.$t('productModule.uploadPlaceHolderType3'));
      }

      return false;
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.$set(this, 'project_codeData', this.project_codeData);
    var downloadexampleurl = this.getRoot + '/example/sn_example.csv';
    console.log("downloadexampleurl", downloadexampleurl);
    this.$set(this, 'downloadexampleurl', downloadexampleurl); //this.$set(this.formModel, 'model_code', this.model_code);  
    // if (this.setData != undefined) {
    //   Object.assign(this.formModel,this.setData);
    // }
    // if(!this.edit){
    //   this.$set(this.formModel,'model_code',this.model_code)
    // }
  }
};